export default Object.freeze({
  accrual: 0,
  payment: 1,
});
